import { Link, useNavigate, useLocation } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import { useState } from "react";
import Conponents from "./Conponents.js";
import General from "./General.js";
import Attributes from "./Attributes.js";
import Pricing from "./Pricing.js";

 
const AddLabProcedureReportTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { item } = location.state || {}; // Get the passed item data
  const [activeTab, setActiveTab] = useState("General");
 
  // Inline styles for active tab
  const activeTabStyle = {
    borderColor: "#007bff",
  };
 
  // Inline styles for the tab container
  const tabContainerStyle = {
    backgroundColor: "#f8f9fa",
    padding: "10px",
    borderRadius: "5px",
  };
 
  const handleTabSelect = (key) => {
    setActiveTab(key);
  };
 
  const handleCancel = () => {
    navigate("/caseSetting"); // Navigate back to LabProcedureReport
  };
 
  return (
    <>

      <div style={{ width: "1900px", margin: "0 auto", padding: "0px" }}>
        <div className="row">

 
          <div className="col-md-10">
            <h3 style={{ marginBottom: "18px" }}>
              {item ? "Edit Procedure" : "Add Procedure"}
            </h3>
            <Tabs
              activeKey={activeTab}
              onSelect={handleTabSelect}
              id="uncontrolled-tab-example"
              className="mb-3"
              style={tabContainerStyle}
            >
              <Tab eventKey="General" title="General">
                <General procedureData={item} onCancel={handleCancel} />
              </Tab>
              <Tab
                eventKey="Attributes"
                title="Attributes"
                style={activeTab === "Attributes" ? activeTabStyle : {}}
              >
                <Attributes />
              </Tab>
               <Tab
                eventKey="Pricing"
                title="Pricing"
                style={activeTab === "Pricing" ? activeTabStyle : {}}
              >
                <Pricing procedureData={item} onCancel={handleCancel} />
              </Tab>
              <Tab
                eventKey="Component"
                title="Component"
                style={activeTab === "Component" ? activeTabStyle : {}}
              >
                <Conponents />

              </Tab>
             
            </Tabs>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};
 
export default AddLabProcedureReportTable;
 